import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import WhatIs from "./components/WhatIs";
import Comparator from "./components/Comparator";
import Podcast from "./components/Podcast";
import Process from "./components/Process";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AccessibilityDock from "./components/AccessibilityDock";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center p-10 text-center">
          <p className="text-lg font-bold">Algo salió mal. Recarga la página o escríbenos a info@bilbaobianco.com.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Home() {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)] grain" data-testid="page-home">
      <Navbar />
      <main className="relative">
        <Hero />
        <Marquee />
        <WhatIs />
        <Comparator />
        <Podcast />
        <Process />
        <Team />
        <Contact />
      </main>
      <Footer />
      <AccessibilityDock />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
